/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum UserState {
  Normal = 0,
  NotRegister = 1,
  NotOrganization = 2,
  NotActive = 3,
  NotAuthenticated = 4,
  ExpireUser = 5,
  NotAuthenticatedUser = 6,
  ExpireOrganization = 7
}
